import { Box, Heading, Text } from "@chakra-ui/react";
import image from "../assets/images/error_404.png";
import { useTranslation } from "react-i18next";

function NotFound() {
    const { t, i18n } = useTranslation();
    return (
        <Box textAlign="center" display="flex" flexDirection="column" alignItems="center" justifyContent="center" py="6">
            <img src={image} alt="not-found-404" />
            <Heading size="lg" color="#FF6666">{t("page_not_found")}</Heading>
        </Box>
    );
}

export default NotFound;
